import styled from "styled-components";

export const View = styled.main`
  display: flex;
  min-height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xxx_large }px;
  background: ${({ theme }) => theme.gradients.background };
`;

export const Card = styled.section`
  display: flex;
  width: min(100%, 560px);
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.x_medium }px;
  padding: ${({ theme }) => theme.spacing.xxx_large }px;
  border: 1px solid ${({ theme }) => theme.glass.border };
  border-radius: ${({ theme }) => theme.border_radius.xlarge }px;
  background-color: ${({ theme }) => theme.glass.background };
  box-shadow: ${({ theme }) => theme.shadow.card };
  backdrop-filter: ${({ theme }) => theme.glass.blur };

  & > span {
    color: ${({ theme }) => theme.colors.info.default };
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: 1;
    font-weight: 800;
    letter-spacing: .14em;
    text-transform: uppercase;
  }

  & > h1 {
    margin: 0;
    color: ${({ theme }) => theme.colors.text.default };
    font-size: ${({ theme }) => theme.font_size.xxx_large }px;
    line-height: 1.15;
    font-weight: 900;
    letter-spacing: -.04em;
  }

  & > p {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray[ 200 ]};
    font-size: ${({ theme }) => theme.font_size.x_medium }px;
    line-height: 1.55;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.x_small }px;
  margin-top: ${({ theme }) => theme.spacing.x_small }px;
`;
